import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteActionIcon from "../../../../../components/icons/DeleteActionIcon";
import EditActionIcon from "../../../../../components/icons/EditActionIcon";
import { showConfirmationModal } from "../../../../../features/confirmationModal/ConfirmationModalSlice";
import { getLocalizedTimeForRegion } from "../../../../../utils/timeZone";
import styles from "./oneRegion.module.css";

const OneRegion = ({ regionId, name, peakTimeStart, peakTimeEnd, image }) => {
  const { timeZone } = useSelector((state) => state.timeZone);
  const { rolePermissions } = useSelector((state) => state.user);
  const canEdit = rolePermissions.includes("update-regions");
  const canDelete = rolePermissions.includes("delete-regions");

  const localizedPeakTimeStart = getLocalizedTimeForRegion(
    peakTimeStart,
    timeZone
  );
  const localizedPeakTimeEnd = getLocalizedTimeForRegion(peakTimeEnd, timeZone);
  const regionInitial = String(name || "-").trim().charAt(0) || "-";

  const formatPeakTime = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      return "-";
    }

    return `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
  };

  const navigate = useNavigate();

  const handleNavigationToEditRegion = () => {
    navigate("/dashboard/regions/edit-region", {
      state: {
        regionId,
        name,
        localizedPeakTimeStart,
        localizedPeakTimeEnd,
        image,
      },
    });
  };

  const dispatch = useDispatch();

  const handleDeleteRegion = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متأكد من حذف المنطقة ؟",
        data: regionId,
        actionType: "deleteRegion",
      })
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.infoWrapper}>
          <div className={styles.regionIdentity}>
            <div className={styles.regionImageWrapper}>
              {image?.path ? (
                <img
                  src={image.path}
                  alt={image?.name || name}
                  className={styles.regionImage}
                />
              ) : (
                <span className={styles.regionFallback}>{regionInitial}</span>
              )}
            </div>
            <div className={styles.regionText}>
              <span className={styles.regionLabel}>المنطقة</span>
              <h3 className={styles.regionName}>{name || "-"}</h3>
            </div>
          </div>
        </div>
        <div className={styles.timeGrid}>
          <div className={styles.dateWrapper}>
            <span className={styles.timeLabel}>نهاية وقت الذروة</span>
            <span className={styles.timeValue}>
              {formatPeakTime(localizedPeakTimeEnd)}
            </span>
          </div>
          <div className={styles.dateWrapper}>
            <span className={styles.timeLabel}>بداية وقت الذروة</span>
            <span className={styles.timeValue}>
              {formatPeakTime(localizedPeakTimeStart)}
            </span>
          </div>
        </div>
      </div>
      {(canEdit || canDelete) && (
        <div className={styles.optionsWrapper}>
          {canEdit && (
            <button
              type="button"
              className={`${styles.actionButton} ${styles.editAction}`}
              onClick={handleNavigationToEditRegion}
            >
              <EditActionIcon className={styles.svgIcon} />
              <span>التعديل على المنطقة</span>
            </button>
          )}
          {canDelete && (
            <button
              type="button"
              className={`${styles.actionButton} ${styles.deleteAction}`}
              onClick={handleDeleteRegion}
            >
              <DeleteActionIcon className={styles.svgIcon} />
              <span>حذف المنطقة</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default OneRegion;
